module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shapes js-shapes",
    class: {
      'is-visible': _vm.isVisible
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "layer js-first-layer"
  }, [_c('div', {
    staticClass: "shape shape--stick is-45 is-grey is-first"
  })]), _vm._v(" "), _c('div', {
    staticClass: "layer is-second js-second-layer"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d2fe78e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shapes.vue
// module id = 169
// module chunks = 1